import React from 'react';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { SidebarPortal } from '@plone/volto/components';
import View from './View';
import Schema from './schema';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const schema = Schema(props);
  const size = data.size || 'm';
  return (
    <>
      <div className={`ag-spacer ag-spacer--${size} ag-spacer--edit`} aria-hidden="true">
        <span className="ag-spacer__label">Espaçador · {size.toUpperCase()}</span>
      </div>
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};
export default Edit;
